/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HarvestDto } from '../../models/harvest-dto';

export interface GetHarvests$Params {
  facilityGroupId: number;
  filterDate?: string;
}

export function getHarvests(http: HttpClient, rootUrl: string, params: GetHarvests$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<HarvestDto>>> {
  const rb = new RequestBuilder(rootUrl, getHarvests.PATH, 'get');
  if (params) {
    rb.path('facilityGroupId', params.facilityGroupId, {});
    rb.query('filterDate', params.filterDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<HarvestDto>>;
    })
  );
}

getHarvests.PATH = '/api/harvests/facilityGroupId/{facilityGroupId}';
